package br.com.duoma.duomaproducao.ui.theme

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color

// ── Palette ──────────────────────────────────────────────────────────────────
val Green950 = Color(0xFF002201)   // deepest brand green
val Green800 = Color(0xFF1B4D1B)
val Green600 = Color(0xFF2E7D32)
val Green200 = Color(0xFFA5D6A7)
val Green50  = Color(0xFFE8F5E9)
val GreenSurface = Color(0xFFF4F8F3)

val colorScheme = lightColorScheme(
    primary            = Green950,
    onPrimary          = Color.White,
    primaryContainer   = Color(0xFFCCE5C8),
    onPrimaryContainer = Green950,

    secondary          = Green800,
    onSecondary        = Color.White,
    secondaryContainer = Green50,
    onSecondaryContainer = Green950,

    tertiary           = Green600,

    background         = GreenSurface,
    onBackground       = Color(0xFF1A1C1A),

    surface            = Color.White,
    onSurface          = Color(0xFF1A1C1A),
    surfaceVariant     = Color(0xFFE4EDE2),
    onSurfaceVariant   = Color(0xFF3D5239),

    outline            = Color(0xFFB0C4AE),
    outlineVariant     = Color(0xFFD8E8D5),

    surfaceContainerHighest = Color(0xFFD0DFC9),
)

@Composable
fun ProducaoTheme(content: @Composable () -> Unit) {
    MaterialTheme(colorScheme = colorScheme) {
        content()
    }
}
